import { AfterViewInit, Component, forwardRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {AppState } from 'src/app/core/models/app-state.models';
/* import { ConsultationAnsOption } from 'src/app/core/models/consultations.models'; */
import { sessionSelectors } from 'src/app/store/selectors';

@Component({
    selector: 'doc-form-radio-input',
    templateUrl: 'radio-input.component.html',
    styleUrls: ['radio-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DocRadioInputComponent),
        multi: true
    }]
})

export class DocRadioInputComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy, OnChanges {
    private onDestroyed$ = new Subject();

    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;

    @Input() placeholder = '';
    @Input() label = '';

    @Input() maxRows = 3;
    @Input() minRows = 2;
    @Input() autoResize = true;

    @Input() boldLabel = false;


    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    

    options = [
        {
            key: "common.no",
            value: "no"
        },
        {
            key: "common.yes",
            value: "yes"
        }
    ]

    radioValue = '';

    constructor(
        private store: Store<AppState>
    ) {
        
    }


    ngOnInit(): void { }

    ngAfterViewInit() { }

    ngOnChanges(changes: SimpleChanges) { }


    /* getValue(option: RadioOption | ConsultationAnsOption) {
        if (option.hasOwnProperty('value')) {
            return option['value'];
        }
        return ''
    } */

   /*  

    }
 */
    /* isChecked(option) {
        if (this.getValue(option) === 'yes') {
            if (this.value !== 'no' && this.value !== '') {
                return true;
            }
        }
        if (this.getValue(option) === this.value) {
            return true;
        }
        return false;
    } */

    selectionChanged(e: MatRadioChange) {
        this.radioValue = e.value;
        this.value = e.value;
        if (e.value === 'yes') {
            this.value = '';
        }
        this.touched();
        this.changed(this.value);
    }


    writeValue(value: any): void {
        this.value = value ? value : '';
        if (this.value && this.value !== 'no') {
            this.radioValue = 'yes'
        }
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    ngOnDestroy() {
        this.onDestroyed$.next();
        this.onDestroyed$.complete();
    }
}

interface RadioOption {
    key: string,
    value: string
};